/**
 * @generated SignedSource<<6192d8444b8a18d3badabf03e6177fe8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StatusValue = "ERROR" | "PARTIAL_SUCCESS" | "SKIPPED" | "SUCCESS" | "UNAVAILABLE" | "%future added value";
export type RemoveDatadogIntegrationMutation$variables = Record<PropertyKey, never>;
export type RemoveDatadogIntegrationMutation$data = {
  readonly removeDatadogIntegration: {
    readonly datadogIntegration: {
      readonly configured: boolean;
      readonly enabled: boolean;
      readonly site: string;
      readonly statusInfo: {
        readonly details: ReadonlyArray<{
          readonly at: string | null | undefined;
          readonly component: string;
          readonly message: string | null | undefined;
          readonly status: StatusValue;
        }>;
        readonly status: StatusValue;
      };
    } | null | undefined;
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
  };
};
export type RemoveDatadogIntegrationMutation = {
  response: RemoveDatadogIntegrationMutation$data;
  variables: RemoveDatadogIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "DatadogIntegration",
  "kind": "LinkedField",
  "name": "datadogIntegration",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "configured",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "site",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusInfo",
      "kind": "LinkedField",
      "name": "statusInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StatusDetail",
          "kind": "LinkedField",
          "name": "details",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "at",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "component",
              "storageKey": null
            },
            (v0/*:: as any*/),
            (v1/*:: as any*/)
          ],
          "storageKey": null
        },
        (v1/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveDatadogIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RemoveDatadogIntegrationPayload",
        "kind": "LinkedField",
        "name": "removeDatadogIntegration",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v0/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RemoveDatadogIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RemoveDatadogIntegrationPayload",
        "kind": "LinkedField",
        "name": "removeDatadogIntegration",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v0/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2ad0704095c77b774e1c4d334be4c7a5",
    "id": null,
    "metadata": {},
    "name": "RemoveDatadogIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveDatadogIntegrationMutation {\n  removeDatadogIntegration {\n    datadogIntegration {\n      configured\n      enabled\n      site\n      statusInfo {\n        details {\n          at\n          component\n          message\n          status\n        }\n        status\n      }\n    }\n    problems {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ec62bcd875962fbd0d006e3049cdf5be";

export default node;
